import api from "../services";

const payRollApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPayRollData: builder.query({
      query: (params) => ({
        url: `api/payslipmanagement/payrollgridemployeesdetails`,
        method: "GET",
        params,
      }),
    }),
    getPayRollDataByEmployees: builder.query({
      query: (params) => ({
        url: `api/payslipmanagement/exportpayrollgrid`,
        method: "GET",
        params,
      }),
    }),
    downloadPayrollsData: builder.mutation({
      query: ({ payrollProcessedDate }) => ({
        url: "api/payslipmanagement/exportpayrollgrid",
        method: "POST",
        params: { payrollProcessedDate },
        responseHandler: (response) => {
          if (!response.ok) {
            return { error: response.statusText, status: response.status };
          }
          return response.blob();
        },
      }),
    }),
  }),
});

export default payRollApi;
export const {
  useLazyGetPayRollDataQuery,
  useDownloadPayrollsDataMutation,
  useLazyGetPayRollDataByEmployeesQuery,
} = payRollApi;
